import { render, staticRenderFns } from "./StudentSchedule.vue?vue&type=template&id=a0a39ef4&scoped=true"
import script from "./StudentSchedule.vue?vue&type=script&lang=js"
export * from "./StudentSchedule.vue?vue&type=script&lang=js"
import style0 from "./StudentSchedule.vue?vue&type=style&index=0&id=a0a39ef4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a39ef4",
  null
  
)

export default component.exports